import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-medical-history',
 
  templateUrl: './medical-history.component.html',
  styleUrl: './medical-history.component.scss'
})
export class MedicalHistoryComponent implements OnInit {
  formName: string = 'medical-history';
  studyId: string | null = null;
  subjectId: string | null = null;
  studyCode: any;
  studyName: any;
  siteLocation: any;
  subjectName: string | null;
  todayDate: string;
//query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: {
    selectedField: any; threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] 
}[] = [
  { selectedField: null, threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end
  formData: any = {
    medicalHistory: '',
    medicalHistoryLogs: []
  };
  folderName: any;

   //review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  private questionMapping: { [key: string]: { question: string, field: string }[] } = {
   /* 'medical-history': [
      { question: 'Does the subject have any relevant medical history', field: 'medicalHistory' }
    ]*/
  };
  informedConsentDate: any;
  screeningMinDate: any;
  gender: any;
    //edit thing
  isMedicalLogDisabled: boolean = false;
isReasonModalOpen: boolean = false;
editReason: string = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {

     const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);
     this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
    const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);
    const today = new Date();
    this.todayDate = today.toISOString().split('T')[0];

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'medical-history';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
             // Dynamically update informedConsentDate from the response
             if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }
  //


  addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}







  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
     if (this.formName === 'medical-history') {
    // Loop over all logs and fetch history (like above)
    this.fieldHistoryData = [];

    this.formData.adverseEventLogs.forEach((_, index) => {
      const fieldName = `medicalHistoryLogs${index + 1}`;

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      ).subscribe({
        next: (response) => {
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
          }
        },
        error: (error) => {
          console.error('Error fetching field history for', fieldName, error);
        }
      });
    });
  } else {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }
  }
}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;

  this.fieldHistoryData = [];

  if (
    this.formName === 'medical-history' &&
    Array.isArray(this.formData.medicalHistoryLogs)
  ) {
    const allReviewEntries: any[] = [];

    let completedRequests = 0;
    const totalRequests = this.formData.medicalHistoryLogs.length;

    this.formData.medicalHistoryLogs.forEach((_, idx) => {
      const fieldName = `medicalHistoryLogs${idx + 1}`;
      console.log('Fetching Field History for:', fieldName);

      this.apiService
        .getInsertHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldName
        )
        .subscribe({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.fieldHistoryData.push(...response.data);
              allReviewEntries.push(...response.data);
            }

            completedRequests++;

            if (completedRequests === totalRequests) {
              this.calculateLatestReviewFlags(allReviewEntries);
            }
          },
          error: (err) => {
            console.error(`Error fetching field history for ${fieldName}:`, err);
            completedRequests++;
            if (completedRequests === totalRequests) {
              this.calculateLatestReviewFlags(allReviewEntries);
            }
          }
        });
    });

  } else {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Opening Review Modal - Fetching Field History for:', fieldName);

    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        this.fieldHistoryData = response.data || [];
        this.calculateLatestReviewFlags(this.fieldHistoryData);
      },
      error: (error) => {
        console.error('Error fetching field history data from review modal:', error);
      }
    });
  }
}
calculateLatestReviewFlags(historyData: any[]) {
  let latestReview = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  const sortedData = [...historyData].sort(
    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  const flagsFound = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  for (const entry of sortedData) {
    if (!entry.review_status) continue;

    try {
      const parsed = JSON.parse(entry.review_status);

      if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
        latestReview.dataMonitor = parsed.dataMonitor;
        flagsFound.dataMonitor = true;
      }

      if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
        latestReview.monitor = parsed.monitor;
        flagsFound.monitor = true;
      }

      if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
        latestReview.pi = parsed.pi;
        flagsFound.pi = true;
      }

      if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
        break;
      }

    } catch (err) {
      console.error("Error parsing review_status JSON:", err);
    }
  }

  this.reviewOptions = latestReview;
  console.log("✅ Final reviewOptions applied:", this.reviewOptions);
}


closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;

  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}



openModal() {
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel || 'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

return {
  selectedField: entry.auditTrail?.[0]?.selectedField || '',
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
           selectedField: null,
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
         selectedField: null,
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });


// ✅ Now fetch all field history data (new block for adverse-event-report)
  if (this.formName === 'medical-history' && Array.isArray(this.formData.medicalHistoryLogs)) {
    this.fieldHistoryData = []; // Clear before adding new

    this.formData.medicalHistoryLogs.forEach((_, index) => {
      const historyFieldName = `medicalHistoryLogs${index + 1}`; // log1, log2...

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        historyFieldName
      ).subscribe({
        next: (response) => {
          console.log(`History for ${historyFieldName}:`, response);
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data); // Merge history entries
          }
        },
        error: (error) => {
          console.error(`Error fetching history for ${historyFieldName}:`, error);
         }
      });
    });
  }
}

getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
     selectedField: null,
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }
  
  if (!query.selectedField) {
  console.warn('No field selected for the query.');
  alert('Please select a field from the dropdown before submitting.');
  return;
}

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    selectedField: query.selectedField || '' // <-- ADD THIS LINE
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}

//
  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }
  updateEndDateRange(log: any) {
    if (log.startDate) {
      log.minEndDate = log.startDate;
    }
  }
  /*
  mapFormData(data: any[]): void {
    //this.formData.medicalHistory = '';  // Initialize the medicalHistory as empty
    // data.forEach(item => {
    //   const subData = JSON.parse(item.sub_data); // Parse sub_data string to object
    this.formData.medicalHistoryLogs = []; // Initialize the medicalHistoryLogs array

    data.forEach(item => {
       let subData: any = {};
    try {
      subData = JSON.parse(item.sub_data);
    } catch (e) {
      console.warn('Invalid JSON in sub_data:', item.sub_data);
      return;
    }
        if (item.field_name.includes('medical history')) {  // Ensure the relevant field is processed
            this.formData.medicalHistory = item.value;  // Set the main medical history (Yes/No)

            // Parse the sub_data string into an object
            //const subData = JSON.parse(item.sub_data);

            // Push the parsed log data into the medicalHistoryLogs array
            subData.forEach(log => {
                this.formData.medicalHistoryLogs.push({
                    logLine: log.logLine || '',
                    medicalCondition: log.medicalCondition || '',
                    startDate: log.startDate || '',
                    endDate: log.endDate || '',
                    ongoing: log.ongoing || '',
                    severity: log.severity || '',
                    medicationTaken: log.medicationTaken || ''
                });
            });

        }
    });

    console.log("Mapped Medical History Data:", this.formData);
                 this.isMedicalLogDisabled = this.formData.medicalHistoryLogs.some(log =>
  log.logLine || log.drugName || log.indication || log.startDate || log.endDate || log.route || log.dosage || log.frequency || log.ongoing
);
}

  */
 hasMedicalHistoryData = false; // Add at top of class if not already

mapFormData(data: any[]): void {
  this.formData.medicalHistoryLogs = [];
  this.hasMedicalHistoryData = false;

  this.reviewOptions = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  data.forEach(item => {
    const fieldName = item.field_name?.trim().toLowerCase();
    const fieldValue = item.value;

    // Handle review checkboxes
    if (fieldName === 'reviewedbydatamonitor') {
      this.reviewOptions.dataMonitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedbymonitor') {
      this.reviewOptions.monitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedbypi') {
      this.reviewOptions.pi = fieldValue === 'true';
    }

    // Handle medical history log entries
    if ((fieldName?.includes('medicalhistorylogs') || fieldName?.includes('medical history logs')) && item.sub_data) {
      let subData: any = {};
      try {
        subData = typeof item.sub_data === 'string' && item.sub_data.trim()
          ? JSON.parse(item.sub_data)
          : {};
      } catch (e) {
        console.warn('Invalid JSON in sub_data:', item.sub_data);
        return;
      }

      this.formData.medicalHistoryLogs.push({
        logLine: subData.logLine || '',
        drugName: subData.drugName || '',
        indication: subData.indication || '',
        startDate: subData.startDate || '',
        endDate: subData.endDate || '',
        route: subData.route || '',
        dosage: subData.dosage || '',
        frequency: subData.frequency || '',
        ongoing: subData.ongoing || ''
      });

      this.hasMedicalHistoryData = true;
    }
  });

  // Disable form if any field has data
  this.isMedicalLogDisabled = this.formData.medicalHistoryLogs.some(log =>
    Object.values(log).some(value => value !== '' && value !== null)
  );

  if (this.formData.medicalHistoryLogs.length === 0) {
    this.addLogLine();
  }

  console.log("✅ Mapped Medical History Data:", this.formData);
  console.log("✅ Review Options:", this.reviewOptions);
}


  addLogLine() {
    if (!Array.isArray(this.formData.medicalHistoryLogs)) {
      this.formData.medicalHistoryLogs = [];
    }
  
    this.formData.medicalHistoryLogs.push({
      logLine: '',
      medicalCondition: '',
      startDate: '',
      endDate: '',
      ongoing:  '',
      severity:  '',
      medicationTaken:  ''
    });
}

navigateToConcomitantMedication(): void {
  if (this.studyId && this.subjectId) {
    this.router.navigate(['/folders/concomitant-medication/concomitant-medication-log'], {
      queryParams: { studyId: this.studyId, subjectId: this.subjectId }
    });
  } else {
    console.error('Missing studyId or subjectId');
  }
}

  extractMedicalHistoryLogs(): any[] {
    if (!Array.isArray(this.formData.medicalHistoryLogs)) {
      return [];
    }
    
    return this.formData.medicalHistoryLogs.map(log => ({
      logLine: log.logLine ?? '',
      medicalCondition: log.medicalCondition ?? '',
      startDate: log.startDate ?? '',
      endDate: log.endDate ?? '',
      ongoing: log.ongoing ?? '',
      severity: log.severity ?? '',
      medicationTaken: log.medicationTaken ?? ''
    }));
  }
   
  editStudy() {
  this.isReasonModalOpen = true;
}

confirmEditReason() {
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }
  this.isMedicalLogDisabled = false; // Enable inputs after confirmation
  this.isReasonModalOpen = false;
}

cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}
//
submitForm() {
    console.log("Before Extracting Logs:", this.formData);

     const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;

    let questionAnswers: { [key: string]: any } = {};

    if (this.formName === 'medical-history' && Array.isArray(this.formData.medicalHistoryLogs)) {
        this.formData.medicalHistoryLogs.forEach((log, index) => {
            let fieldKey = `medicalHistoryLogs${index + 1}`;

            questionAnswers[fieldKey] = {
                answer: 'Yes',
                value: {
                    logLine: log.logLine ?? '',
      medicalCondition: log.medicalCondition ?? '',
      startDate: log.startDate ?? '',
      endDate: log.endDate ?? '',
      ongoing: log.ongoing ?? '',
      severity: log.severity ?? '',
      medicationTaken: log.medicationTaken ?? ''
                },
               editReason: this.editReason || '',
                reviewStatus: { ...this.reviewOptions }
            };
        });
    }

    console.log("Submitted Data:", questionAnswers);

    const submittedData = {
        folderName: this.folderName,
        formName: this.formName,
        studyId: this.studyId,
        subjectId: this.subjectId,
        user: fullName, 
        ...questionAnswers
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
        next: (response) => {
            console.log("Response from API:", response);
            alert("Form Submitted Successfully!");
            this.editReason = '';
            this.isMedicalLogDisabled = true;


        },
        error: (error) => {
            console.error("Error submitting form:", error);
            alert("Error submitting form. Please try again.");
        }
    });
}
/*
  submitForm() {
    console.log("Before Extracting Logs:", this.formData.medicalHistoryLogs);
   const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
    let questionAnswers: { [key: string]: any } = {};
  
    if (this.formName && this.questionMapping[this.formName]) {
      this.questionMapping[this.formName].forEach((mapping, index) => {
        let fieldKey = `medicalHistoryLogs${index + 1}`; // Fixed template literal
    
        if (this.formName === 'medical-history') {
          if (this.formData.medicalHistory === 'Yes') 
            {
            const medicalHistoryLogs = this.extractMedicalHistoryLogs();
            console.log("Extracted Medical History Logs:", medicalHistoryLogs);
    
            questionAnswers[fieldKey] = {
              answer: 'Yes',
              value: medicalHistoryLogs,
               editReason: this.editReason || ''
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        }
      });
    }
  
    console.log("Submitted Data:", questionAnswers);
    
    const submittedData = {
      folderName: "medical-history",
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
         user: fullName, 
      ...questionAnswers
    };
  
    console.log("Form Submitted:", submittedData);
  
    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");
         this.editReason = '';
            this.isMedicalLogDisabled = true;
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }
  
*/
  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }
  //new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }
}